<template>
	<div>
		<el-row style="margin-top: 75px;">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				员工离职-详情</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>
		</el-row>

		<div style="margin:0px 40px 0 40px; height: 800px; background-color: #FFFFFF;">

			<div style="height: 30px;"></div>
			<div
				style="border-left: 3px #006E48 solid; margin-left: 5%; border-bottom: 1px #f8f8f8 solid; margin-right: 5%;">
				<span style="font-size:20px;font-weight:700">基础信息</span>
			</div>

			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label">姓名：</lable>
					<span>{{ruleForm.staff.staff_name}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">身份证号码：</lable>
					<span>{{ruleForm.staff.staff_card}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">手机号：</lable>
					<span>{{ruleForm.staff.staff_telephone}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">入职日期：</lable>
					<span>{{ruleForm.staff.induction_time}}</span>
				</el-col>
			</el-row>
			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label">组织架构：</lable>
					<span>{{ruleForm.staff.range}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">城市：</lable>
					<span>{{ruleForm.staff.city_id}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">职位：</lable>
					<span>{{ruleForm.staff.post_name}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">入职薪酬：</lable>
					<span>{{ruleForm.staff.induction_salary}}</span>
				</el-col>
			</el-row>

			<div
				style="border-left: 3px #006E48 solid; margin-top: 60px; margin-left: 5%; border-bottom: 1px #f8f8f8 solid; margin-right: 5%;">
				<span style="font-size:20px;font-weight:700">离职信息</span>
			</div>
			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label">离职日期：</lable>
					<span>{{ruleForm.quit_date}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">离职原因：</lable>
					<span>{{ruleForm.dictionaries_data}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">离职提交日期：</lable>
					<span>{{ruleForm.quit_time}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">操作人：</lable>
					<span>{{ruleForm.operator}}</span>
				</el-col>
			</el-row>
			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label">备注：</lable>
					<span>{{ruleForm.remarks == null || ruleForm.remarks == '' ? '无' : ruleForm.remarks}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">离职审批表：</lable>
					<el-image style="width: 100px; height: 100px" :src="ruleForm.quit_url">
					</el-image>
				</el-col>
			</el-row>

			<div
				style="border-left: 3px #006E48 solid; margin-top: 60px; margin-left: 5%; border-bottom: 1px #f8f8f8 solid; margin-right: 5%;">
				<span style="font-size:20px;font-weight:700">保险信息</span>
			</div>

			<el-row>
				<el-table :data="ruleForm.staff.dangerList" border style="width: 80%;margin:20px 10%">
					<el-table-column prop="dangerType" align="center" label="保险类型"></el-table-column>
					<el-table-column prop="danger_dete" align="center" label="出险时间"></el-table-column>
					<el-table-column prop="indemnity_amount" align="center" label="赔付金额">
					</el-table-column>
					<el-table-column prop="settlement_status" align="center" label="理赔状态">
					</el-table-column>
				</el-table>
			</el-row>

		</div>
	</div>
</template>

<script>
	export default {
		props: ["ruleForm"],
		data() {
			return {};
		},
		methods: {
			Return() {
				this.$emit("return");
			},
		},
		created() {},
	};
</script>

<style scoped="scoped">
	.label {
		color: #b3b3b3;
	}
</style>



// WEBPACK FOOTER //
// Yglz_edit.vue?2d57e9a3